// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export {
  listGremlinRoleAssignments,
  deleteGremlinRoleAssignment,
  createUpdateGremlinRoleAssignment,
  getGremlinRoleAssignment,
  listGremlinRoleDefinitions,
  deleteGremlinRoleDefinition,
  createUpdateGremlinRoleDefinition,
  getGremlinRoleDefinition,
  retrieveContinuousBackupInformation,
  listGremlinGraphs,
  deleteGremlinGraph,
  createUpdateGremlinGraph,
  getGremlinGraph,
  listGremlinDatabases,
  deleteGremlinDatabase,
  createUpdateGremlinDatabase,
  getGremlinDatabase,
  migrateGremlinGraphToManualThroughput,
  migrateGremlinGraphToAutoscale,
  updateGremlinGraphThroughput,
  getGremlinGraphThroughput,
  migrateGremlinDatabaseToManualThroughput,
  migrateGremlinDatabaseToAutoscale,
  updateGremlinDatabaseThroughput,
  getGremlinDatabaseThroughput,
} from "./operations.js";
export type {
  GremlinResourcesListGremlinRoleAssignmentsOptionalParams,
  GremlinResourcesDeleteGremlinRoleAssignmentOptionalParams,
  GremlinResourcesCreateUpdateGremlinRoleAssignmentOptionalParams,
  GremlinResourcesGetGremlinRoleAssignmentOptionalParams,
  GremlinResourcesListGremlinRoleDefinitionsOptionalParams,
  GremlinResourcesDeleteGremlinRoleDefinitionOptionalParams,
  GremlinResourcesCreateUpdateGremlinRoleDefinitionOptionalParams,
  GremlinResourcesGetGremlinRoleDefinitionOptionalParams,
  GremlinResourcesRetrieveContinuousBackupInformationOptionalParams,
  GremlinResourcesListGremlinGraphsOptionalParams,
  GremlinResourcesDeleteGremlinGraphOptionalParams,
  GremlinResourcesCreateUpdateGremlinGraphOptionalParams,
  GremlinResourcesGetGremlinGraphOptionalParams,
  GremlinResourcesListGremlinDatabasesOptionalParams,
  GremlinResourcesDeleteGremlinDatabaseOptionalParams,
  GremlinResourcesCreateUpdateGremlinDatabaseOptionalParams,
  GremlinResourcesGetGremlinDatabaseOptionalParams,
  GremlinResourcesMigrateGremlinGraphToManualThroughputOptionalParams,
  GremlinResourcesMigrateGremlinGraphToAutoscaleOptionalParams,
  GremlinResourcesUpdateGremlinGraphThroughputOptionalParams,
  GremlinResourcesGetGremlinGraphThroughputOptionalParams,
  GremlinResourcesMigrateGremlinDatabaseToManualThroughputOptionalParams,
  GremlinResourcesMigrateGremlinDatabaseToAutoscaleOptionalParams,
  GremlinResourcesUpdateGremlinDatabaseThroughputOptionalParams,
  GremlinResourcesGetGremlinDatabaseThroughputOptionalParams,
} from "./options.js";
